import React, { useMemo } from 'react'
import { Text, Flex, VStack } from '@chakra-ui/react'
import { insertCharIntoString } from 'utils/functions/formatString'
import { IDashboardCompany } from 'services/IApi.d'

interface Props {
  data?: IDashboardCompany
}

const CompanyResume: React.FunctionComponent<Props> = ({ data = {name: '',document: { type: '', number: '' }} }) => {
  const { name:nombreEmpresa,  document: { type: tipoDocumento, number: nroDocumento } } = data
  const data11 = 11

  const nroDocSecondHyphen = useMemo (() => { 
    if (nroDocumento !=='') {
      const nroDocFirstHyphen = insertCharIntoString(nroDocumento, 2, '-')
      return insertCharIntoString(nroDocFirstHyphen, data11, '-')
    } else {
      return ''
    }
  }, [nroDocumento])


  return (
    <VStack spacing={1} alignItems='start'>
      <Text mb='2' textStyle='labelLg'>Solicitud para la empresa</Text>
      <Text textStyle='h4Bold'>{nombreEmpresa}</Text>
      <Flex>
        <Text mr='2' textStyle='bodyMd'>
          {tipoDocumento}
        </Text> 
        <Text textStyle='bodyMdSemi'>
          {nroDocSecondHyphen}
        </Text>
      </Flex>
    </VStack>
  )
}

export default CompanyResume
